import { createAuthedHttpClient, deleteAccessToken, redirectToLoginPage } from '@driftt/web-auth'
import { CUSTOMER_API, CONVERSATION_API, AUTH_CLIENT_ID } from 'constants/ResourcesConstants'

const redirectToLoginOnAuthError = (error) => {
  if (error.response.status === 401 || error.response.status === 403) {
    deleteAccessToken()
    redirectToLoginPage(AUTH_CLIENT_ID)
  }
}

export const CustomerAPIAuthEnabled = createAuthedHttpClient({
  baseConfig: {
    baseURL: `${CUSTOMER_API}`,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError]
})

export const ConversationAPIAuthEnabled = createAuthedHttpClient({
  baseConfig: {
    baseURL: `${CONVERSATION_API}`,
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError]
})



// WEBPACK FOOTER //
// ./src/scripts/app/auth-requests/api.js